import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import style from '../../../style/components/profile/emails/EmailStatusBadge.module.scss';

const StatusRow = ({ className, iconName, label, date, t }) => (
  <span className={className}>
    <idme-icon name={iconName} size="small" />
    <span>
      <span className={style.statusText}>{t(label)}</span>
      {date && (
        <span className={style.dateText}>
          {t('walletEmails.onDate', { date })}
        </span>
      )}
    </span>
  </span>
);

StatusRow.propTypes = {
  className: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  date: PropTypes.string,
  t: PropTypes.func.isRequired,
};

const EmailStatusBadge = ({ status, date }) => {
  const { t } = useTranslation();

  if (status === 'verified') {
    return (
      <StatusRow
        className={style.verified}
        iconName="check-circle"
        label="walletEmails.verified"
        date={date}
        t={t}
      />
    );
  }

  if (status === 'verified_pending_review') {
    return (
      <StatusRow
        className={style.underReview}
        iconName="clock"
        label="walletEmails.underReview"
        date={date}
        t={t}
      />
    );
  }

  return (
    <span className={style.notVerified}>
      <idme-icon name="alert-triangle" size="small" />
      <span className={style.statusText}>{t('walletEmails.notVerified')}</span>
    </span>
  );
};

EmailStatusBadge.propTypes = {
  status: PropTypes.oneOf(['verified', 'pending', 'verified_pending_review'])
    .isRequired,
  date: PropTypes.string,
};

export default memo(EmailStatusBadge);
